<div 
    class="buy-in-type" 
    (click)="selectBuyIn()"    
    [ngClass]="calculateClass()"> 
    {{ buyInType.name }}       
</div>
